import Signin from "components/login/Signin.jsx";
import Signup from "components/login/Signup.jsx";
import ForgetPassword from "components/login/ResetPass.jsx";
import ResetPassword from "components/ResetPassword/ResetPassword";

const AUTH_ROUTES = [
  {
    path: "/auth/forget-password",
    component: ForgetPassword,
    name: "ForgetPassword",
    needAuth: false,
  },
  {
    path: "/auth/reset-password",
    component: ResetPassword,
    name: "ResetPassword",
    needAuth: false,
  },
  {
    path: "/auth/SignUp",
    component: Signup,
    name: "SignUp",
    needAuth: false,
  },
  {
    path: "/auth/SignIn",
    component: Signin,
    name: "SignIn",
    needAuth: false,
  },
];

export default AUTH_ROUTES;
